import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    submit_btn_disable: false,
    visibility: false,

    generated_result: null,
    avatar_name: ''
  },
  mutations: {
    INIT_SUBMIT_AVATAR_DIALOG(state, payload) {
      state.generated_result = payload
      state.visibility = true
      state.avatar_name = ''
    },
    SET_SUBMIT_AVATAR_DIALOG_SUBMIT_BTN_DISABLE(state, payload) {
      state.submit_btn_disable = payload
    },
    RESET_SUBMIT_AVATAR_DIALOG(state) {
      state.generated_result = null
      state.visibility = false
      state.avatar_name = ''
    },

    SET_SUBMIT_AVATAR_DIALOG_AVATAR_NAME(state, payload) {
      state.avatar_name = payload
    }
  },
  actions: {
    async submitAvatar({ rootState, state, commit, dispatch }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.loading', ''), loading: true })
        commit('SET_SUBMIT_AVATAR_DIALOG_SUBMIT_BTN_DISABLE', true)

        const device_id = rootState.auth.selected_device
        const { image_id } = state.generated_result
        const name = state.avatar_name

        const response = await api.submitGeneratedVideoAvatar({ params: { device_id, image_id, name } })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.success', ''), icon: 'check', timeout: '2000' })
          commit('RESET_SUBMIT_AVATAR_DIALOG')
          commit('RESET_CREATE_AVATAR_DIALOG')
          dispatch('fetchVirtualAvatarList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_SUBMIT_AVATAR_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
